import React from 'react';
import ReactPlayer from 'react-player';

const Scenario3Video6 = () => {
    return (
        <div className='Scenario1VideoWrap Scenario1Video3'>
            <ReactPlayer url='https://youtu.be/AuJ2u_MNi1o' controls={true} />
        </div>
    );
}

export default Scenario3Video6;